export default __webpack_public_path__ + "static/media/707.0e815042.png";